// Utilitaires géométriques (fusion spatiale XML <-> cadastre).

export function polygonCentroid(ring) {
  if (!ring || ring.length === 0) return null;
  let lat = 0;
  let lng = 0;
  for (const [a, b] of ring) {
    lat += a;
    lng += b;
  }
  return [lat / ring.length, lng / ring.length];
}

// Ray casting. point = [lat, lng], ring = [[lat, lng], ...]
export function pointInPolygon(point, ring) {
  if (!ring || ring.length < 3) return false;
  const [y, x] = point;
  let inside = false;
  for (let i = 0, j = ring.length - 1; i < ring.length; j = i++) {
    const yi = ring[i][0];
    const xi = ring[i][1];
    const yj = ring[j][0];
    const xj = ring[j][1];
    const intersect =
      yi > y !== yj > y && x < ((xj - xi) * (y - yi)) / (yj - yi) + xi;
    if (intersect) inside = !inside;
  }
  return inside;
}

// Fusionne une entrée d'historique de culture (une seule entrée par campagne).
export function mergeHistory(hist, entry) {
  const h = (hist || []).filter((e) => e.year !== entry.year);
  h.push(entry);
  h.sort((a, b) => a.year - b.year);
  return h;
}

// Variante : enrichit `targets` à partir d'une liste de parcelles Télépac fournie.
export function assignCropUsing(targets, xmlParcels) {
  const xs = (xmlParcels || []).filter((x) => x.polygon && x.polygon.length >= 3);
  if (xs.length === 0) return targets;
  for (const p of targets) {
    if (p.source === "xml" || !p.polygon || p.polygon.length < 3) continue;
    const c = polygonCentroid(p.polygon);
    if (!c) continue;
    const match = xs.find((x) => pointInPolygon(c, x.polygon));
    if (match && match.crop) {
      p.crop = match.crop;
      p.crop_label = match.crop_label || match.crop;
      if (match.campaign) {
        p.crop_history = mergeHistory(p.crop_history, {
          year: match.campaign,
          crop: match.crop,
          crop_label: p.crop_label,
        });
      }
    }
  }
  return targets;
}
export function assignCropFromXml(parcels) {
  const xmlParcels = parcels.filter((p) => p.source === "xml" && p.polygon && p.polygon.length >= 3);
  if (xmlParcels.length === 0) return parcels;
  return parcels.map((p) => {
    if (p.source === "xml" || !p.polygon || p.polygon.length < 3) return p;
    const c = polygonCentroid(p.polygon);
    if (!c) return p;
    const match = xmlParcels.find((x) => pointInPolygon(c, x.polygon));
    if (match && match.crop) {
      return { ...p, crop: match.crop, crop_label: match.crop_label || match.crop };
    }
    return p;
  });
}
